export const buildPageName = (channel: string, pageName?: string) =>
  `${channel}:search:ad-view${pageName ?? ""}`;

export const buildLeasingPageName = (channel: string) =>
  `${channel}:leasing:product`;
